import { axiosClientServices as axiosClient } from "@duosoftbg/nacid-frontoffice-components";

const endpoints = {
  getSchoolSubjects: "/school-subjects",
};

export const getSubjectBgByName = (name) => async () => {
  const response = await axiosClient.get(`${endpoints.getSchoolSubjects}`, {
    params: {
      name,
    },
  });
  return response.data;
};
